/** @jsx jsx */
/* eslint-disable no-use-before-define */
import { jsx } from '@emotion/core'
import React from 'react'
import { resultListCss } from '../style'
import { useCalculator } from '../use-calculator'
import { fmt, isEmpty } from '../../twd'

export const YieldTable = () => {

    const { calcOutput:co, bondInfo } = useCalculator()

    if (isEmpty(bondInfo)) return null

    const issue = bondInfo.issue || {}
    const hasDisc = ['A','C','T'].indexOf(issue.type)>=0
        && issue.category==='B'

    return <React.Fragment>
        <h3>Price/Yields (Per bond)</h3>
        <dl css={resultListCss}>
            <dt>Price</dt>
            <dd>{fmt.price3(co.price)}</dd>

            {hasDisc && <React.Fragment>
                <dt>Discount</dt>
                <dd>{fmt.ytw3(co.discountYield)}</dd>
                </React.Fragment>}

            <dt>{ isEmpty(co.ytw) ? null : <React.Fragment>({fmt.mdy(co.ytwDate)}@{fmt.price0(co.ytwPrice)}) </React.Fragment>}YTW</dt>
            <dd>{fmt.ytw3(co.ytw)}</dd>
            <dt>{ isEmpty(co.ytm) ? null : <React.Fragment>({fmt.mdy(co.ytmDate)}@{fmt.price0(co.ytmPrice)}) </React.Fragment>}YTM</dt>
            <dd>{fmt.ytw3(co.ytm)}</dd>
            <dt>{ isEmpty(co.ytc) ? null : <React.Fragment>({fmt.mdy(co.ytcDate)}@{fmt.price0(co.ytcPrice)}) </React.Fragment>}YTC</dt>
            <dd>{fmt.ytw3(co.ytc)}</dd>
            <dt>Yield-to-Sink</dt>
            <dd>{fmt.ytw3(co.yts)}</dd>
            <dt>Yield-to-Put</dt>
            <dd>{fmt.ytw3(co.ytp)}</dd>
            <dt>Yield-to-Par Call</dt>
            <dd>{fmt.ytw3(co.ytpc)}</dd>
            <dt>Cur Yield</dt>
            <dd>{fmt.ytw3(co.currentYield)}</dd>
            <dt>Duration</dt>
            <dd>{fmt.dur(co.duration)}</dd>
            <dt>Convexity</dt>
            <dd>{fmt.cty(co.convexity)}</dd>
            <dt>{fmt.count(co.accruedIntDays)} Days Acc. Int</dt>
            <dd>{fmt.money(co.accruedIntPerBond)}</dd>
        </dl>
    </React.Fragment>
}


// WEBPACK FOOTER //
// ./src/calculator/calc-output/yield-table.js